<div class="features-section">

  <div class="features-header">
    <p class="features-label">HR Features</p>
    <h2>Powerful HR tools with friendly design</h2>
    <p class="features-intro">A thoughtfully built feature set that makes managing people, payroll, leave, and performance effortless.</p>
  </div>

  <div class="features-shell">

    <div class="feature-item">
      <span class="feature-icon">🌟</span>
      <div class="feature-body">
        <h3>Recruitment & Onboarding</h3>
        <p>Manage job postings, applicant tracking, interview scheduling and automated onboarding checklists to get new hires productive fast.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">💰</span>
      <div class="feature-body">
        <h3>Payroll & Benefits</h3>
        <p>Accurate payroll processing, tax calculations, and benefits administration with configurable pay cycles and transparent payslips.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">⏱️</span>
      <div class="feature-body">
        <h3>Attendance & Time Tracking</h3>
        <p>Track clock-ins, shift schedules, overtime, and integrate attendance with leave and payroll rules in real time.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">🌴</span>
      <div class="feature-body">
        <h3>Leave & Time Off</h3>
        <p>Self-service leave requests, approvals, accrual policies and a unified calendar for complete team availability.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">🎯</span>
      <div class="feature-body">
        <h3>Performance Management</h3>
        <p>Run goal-setting cycles, 1:1s, reviews, and continuous feedback to drive employee growth and retention.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">🧑‍💼</span>
      <div class="feature-body">
        <h3>Employee Self-Service</h3>
        <p>Allow employees to update profiles, download payslips, request time off, and access personal HR documents instantly.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">🎓</span>
      <div class="feature-body">
        <h3>Learning & Development</h3>
        <p>Create training plans, track certifications, and link learning activities to career paths and promotions.</p>
      </div>
    </div>

    <div class="feature-item">
      <span class="feature-icon">📊</span>
      <div class="feature-body">
        <h3>HR Analytics & Reports</h3>
        <p>Built-in dashboards and exportable reports for headcount, turnover, payroll cost, and compliance metrics.</p>
      </div>
    </div>

  </div>

</div>
